// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"css-2VTF9Kpg4p"};